package io.jsonize.web.theme

import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.ui.graphics.Color

/**
 * JSON Editor Theme Colors — can be extended later.
 */
data class JsonEditorColors(
    val background: Color,
    val surface: Color,
    val textColor: Color,
    val accent: Color,
    val error: Color
)

private val lightPalette = JsonEditorColors(
    background = Color(0xFFF7F7F7),
    surface = Color(0xFFFFFFFF),
    textColor = Color(0xFF333333),
    accent = Color(0xFF2196F3),
    error = Color(0xFFD32F2F)
)

private val darkPalette = JsonEditorColors(
    background = Color(0xFF1E1E1E),
    surface = Color(0xFF252526),
    textColor = Color(0xFFD4D4D4),
    accent = Color(0xFF64B5F6),
    error = Color(0xFFFF6B6B)
)

/**
 * CompositionLocal for the theme palette.
 */
val LocalJsonColors = staticCompositionLocalOf { lightPalette }

/**
 * Parent theme wrapper. Use like:
 *
 * JsonTheme {
 *     EditorScreen()
 * }
 */
@Composable
fun JsonTheme(
    dark: Boolean = false,
    content: @Composable () -> Unit
) {
    val colors = if (dark) darkPalette else lightPalette

    CompositionLocalProvider(LocalJsonColors provides colors, content = content)
}

/**
 * Access colors inside components:
 * val colors = JsonTheme.colors
 */
object JsonTheme {
    val colors: JsonEditorColors
        @Composable get() = LocalJsonColors.current
}
